import React from 'react';
import ReactModal from 'react-modal';
import ReactTooltip from 'react-tooltip';
import './style.scss';

ReactModal.setAppElement('body');

export default class Form extends React.Component<any> {
  constructor(props) {
    super(props);
  }

  render() {
    const { datesArray, createdDate } = this.props;
    return (
      <div className="status-container">
        <div className="center">
          <div className="status">
            Estado del débito directo{' '}
            {!datesArray[2].isCompleted && <span>PENDIENTE</span>}
            {datesArray[2].isCompleted && !datesArray[4].isCompleted && (
              <span>ENVIADO AL BANCO</span>
            )}
            {datesArray[4].isCompleted && <span>COMPLETADO</span>}{' '}
          </div>

          <div className="status-result">
            <label>
              Será notificado del pago el día{' '}
              {datesArray[4].date.format('DD/MM/YYYY')}{' '}
            </label>
          </div>
          <div className="status-bar step-size-6">
            <span className={`step step-1 completed`}>
              <span className="text">{createdDate.format('DD/MM/YYYY')}</span>
              <span className="tooltip">
                <span>
                  <i className="fa fa-pencil-square-o" />
                  <p>Formulario enviado</p>
                </span>
              </span>
            </span>
            <span
              className={`step step-2 ${datesArray[0].isCompleted ? 'completed' : ''}`}
            >
              <span className="text">
                {datesArray[0].date.format('DD/MM/YYYY')}
              </span>
            </span>
            <span
              className={`step step-3 ${datesArray[1].isCompleted ? 'completed' : ''}`}
            >
              <span className="text">
                {datesArray[1].date.format('DD/MM/YYYY')}
              </span>
            </span>
            <span
              className={`step step-4 ${datesArray[2].isCompleted ? 'completed' : ''}`}
            >
              <span className="text">
                {datesArray[2].date.format('DD/MM/YYYY')}
              </span>
              <span className="tooltip">
                <span>
                  <i className="fa fa-university" />
                  <p>El banco recibe los datos</p>
                </span>
              </span>
            </span>
            <span
              className={`step step-5 ${datesArray[3].isCompleted ? 'completed' : ''}`}
            >
              <span className="text">
                {datesArray[3].date.format('DD/MM/YYYY')}
              </span>
            </span>
            <span
              className={`step step-6 ${datesArray[4].isCompleted ? 'completed' : ''}`}
            >
              <span className="text">
                {datesArray[4].date.format('DD/MM/YYYY')}
              </span>
              <span className="tooltip">
                <span>
                  <img width={15} src="/static/booking-logo.png" />
                  <p>Booking recibe los datos</p>
                </span>
              </span>
            </span>
          </div>

          <div className="disclaimer">
            <div className="warning-box margin-bottom margin-top">
              <p />
              <p>
                <i className="icon fa fa-exclamation-triangle" />
                Recuerde que si envió el formulario de débito directo luego de
                las 11 horas el proceso llevará, un día hábil más bancario que
                del indicado en la secuencia que se muestra arriba.
              </p>
              <p>
                <i className="icon fa fa-exclamation-triangle" />
                Se le notificará vía mail cuando el pago sea aceptado o
                rechazado
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
